<template>
    <div id="register">
        <h1>
            Meine Daten ändern
        </h1>

        <form class="md-layout md-alignment-top-center" novalidate @submit.prevent="validateUser">
            <md-card class="md-layout-item md-large-size-50 md-small-size-90">
                <md-card-content>
                    <fieldset>
                        <legend>Persönliche Daten</legend>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('firstName')">
                                    <label for="first-name">Vorname</label>
                                    <md-input id="first-name" v-model="form.firstName" :disabled="sending"
                                              autocomplete="given-name"
                                              name="first-name"/>
                                    <span v-if="!this.$v.form.firstName.required" class="md-error">
                                        Es muss ein Vorname angegeben werden!
                                    </span>
                                    <span v-else-if="!this.$v.form.firstName.minLength" class="md-error">
                                        Der Vorname ist zu kurz!
                                    </span>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('lastName')">
                                    <label for="last-name">Nachname</label>
                                    <md-input id="last-name" v-model="form.lastName" :disabled="sending"
                                              autocomplete="family-name"
                                              name="last-name"/>
                                    <span v-if="!this.$v.form.lastName.required"
                                          class="md-error">
                                        Es muss ein Nachname angegeben werden!
                                    </span>
                                    <span v-else-if="!this.$v.form.lastName.minLength" class="md-error">
                                        Der Nachname ist zu kurz!
                                    </span>
                                </md-field>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Adresse</legend>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('street')">
                                    <label for="street">Straße & Hausnummer</label>
                                    <md-input id="street" v-model="form.street" :disabled="sending"
                                              autocomplete="shipping street-address"
                                              name="street"/>
                                    <span v-if="!this.$v.form.street.required"
                                          class="md-error">
                                        Es muss eine Straße und eine Hausnummer angegeben werden!
                                    </span>
                                    <span v-else-if="!this.$v.form.street.minLength" class="md-error">
                                        Ungültige Straße (mit Hausnummer)!
                                    </span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('zipCode')">
                                    <label for="zipCode">PLZ</label>
                                    <md-input id="zipCode" v-model="form.zipCode" :disabled="sending"
                                              autocomplete="shipping postal-code"
                                              name="zipCode"/>
                                    <span v-if="!this.$v.form.zipCode.required" class="md-error">
                                        Es muss eine PLZ angegeben werden!
                                    </span>
                                    <span v-else-if="!this.$v.form.zipCode.minLength" class="md-error">
                                        Ungültige PLZ
                                    </span>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('city')">
                                    <label for="city">Stadt</label>
                                    <md-input id="city" v-model="form.city" :disabled="sending" autocomplete="address-level2"
                                              name="city"/>
                                    <span v-if="!this.$v.form.city.required" class="md-error">
                                        Es muss eine Stadt angegeben werden!
                                    </span>
                                    <span v-else-if="!this.$v.form.city.minLength" class="md-error">
                                        Ungültige Stadt
                                    </span>
                                </md-field>
                            </div>
                        </div>
                    </fieldset>
                </md-card-content>

                <md-progress-bar v-if="sending" md-mode="indeterminate"/>

                <md-card-actions>
                    <div class="spacer"></div>
                    <md-button :disabled="sending" class="md-primary" to="/user/my_data">Zurück</md-button>
                    <md-button :disabled="sending" class="md-primary md-raised" type="submit">Speichern</md-button>
                </md-card-actions>
            </md-card>
        </form>
    </div>
</template>

<script>
import {minLength, required} from 'vuelidate/lib/validators'

export default {
    name: 'User_Data_edit',
    computed: {
        hint() {
            return "" + this.form.agb + " " + this.$v.form.agb.$invalid + " " + this.$v.form.agb.$error
        }
    },
    data: () => ({
        form: {
            // Personendaten
            firstName: "",
            lastName: "",
            //Address
            street: "",
            zipCode: "",
            city: "",
        },
        userSaved: false,
        sending: false,
        type: null
    }),
    mounted() {
        const t = this
        const i = setInterval(function(){ 
            if(t.$store.state.user){
                // Personendaten
                t.form.firstName = t.$store.state.user.firstName
                t.form.lastName = t.$store.state.user.lastName
                //Address
                t.form.street = t.$store.state.user.address.street
                t.form.zipCode = t.$store.state.user.address.postCode
                t.form.city = t.$store.state.user.address.city
                clearInterval(i)
            }
            }, 10);
    },
    validations() {
        return {
            form: {
                firstName: {
                    required,
                    minLength: minLength(2)
                },
                lastName: {
                    required,
                    minLength: minLength(2)
                },
                street: {
                    required
                },
                zipCode: {
                    required
                },
                city: {
                    required
                },
            }
        }
    },
    methods: {
        getValidationClass(fieldName) {
            const field = this.$v.form[fieldName];

            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        clearForm() {
            this.$v.$reset();
            this.form = {}
        },
        validateUser() {
            this.$v.form.$touch();

            if (!this.$v.$invalid) {

                let form = this.form
                let req = {
                    id: this.$store.state.user.id,
                    firstName: form.firstName,
                    lastName: form.lastName,
                    address: {
                        street: form.street,
                        postCode: form.zipCode,
                        city: form.city,
                        country: "Deutschland" // TODO Land einarbeiten und hier statischen Wert austauschen
                    },
                }

                this.$store.dispatch("editUserData", req).then(() => {
                    this.$v.$reset();
                    this.$router.push("/user/my_data/")
                })
            } else {
                console.log("Vuelidation failed!")
            }
        },
    }
}
</script>

<style lang="scss" scoped>
#register {
    margin: auto;
}

.spacer {
    flex-grow: 1;
}

.md-error {
    color: var(--md-theme-default-fieldvariant, #ff1744);
    font-size: 12px;
}
</style>
